import { Paragraph } from '../../../components/Text';
import LightBulb from '../LightBulb';

import style from './list-item.module.css';

interface ListItemProps {
  lightBulbClassName: string;
  text: string;
}

const ListItem = ({
  lightBulbClassName,
  text,
}: ListItemProps) => {
  return (
    <li className={style.listItem}>
      <LightBulb className={lightBulbClassName} />

      <Paragraph>
        {text}
      </Paragraph>
    </li>
  );
};

export default ListItem;
